import { getRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import CONSTANTS from '../constants'
// import { postRequest, putRequest } from '../../services'
// import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'

// Calls the API to get user token
export const globalKeyStore = (creds) => (dispatch) => {
    return dispatch({ type: CONSTANTS.GLOBAL_STATE_KEY_REQUEST, data: creds })
}

// GET PARTNER BY SLUG
export const getPartnerDetailsBySLug = (slug) => (dispatch) => {
    dispatch(addEventLog(slug, CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_REQUEST))
    dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_REQUEST })
    return getRequest(`${APICONFIG.getPartnerBySlug}/${slug}`).then((res) => {
        let resObject = { ...slug, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_SUCCESS))
        dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_SUCCESS, data: res?.data })
        return res
    }).catch((err) => {
        let errObject = { ...slug, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_FAILURE))
        dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_FAILURE, errorMessage: err })
        return err
    })
}